import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { DisputeCard } from "../components/DisputeCard";
import { PageHeader } from "../components/common";

const FILTERS = [["", "All"], ["needs_response", "Needs response"], ["under_review", "Under review"], ["won", "Won"], ["lost", "Lost"]];

export default function Disputes() {
  const [filter, setFilter] = useState("");
  const [list, setList] = useState(null);
  const [intel, setIntel] = useState({});
  useEffect(() => { api.get("/disputes-intel").then((r) => setIntel(r.data)); }, []);
  useEffect(() => {
    setList(null);
    api.get(`/disputes${filter ? `?status=${filter}` : ""}`).then((r) => setList(r.data));
  }, [filter]);

  return (
    <div data-testid="disputes-page">
      <PageHeader eyebrow="// chargeback docket" title="Disputes">
        <div className="flex border border-line rounded-sm overflow-hidden">
          {FILTERS.map(([v, l]) => (
            <button key={l} onClick={() => setFilter(v)} data-testid={`filter-${v || "all"}`}
              className={`px-3 py-2 font-mono text-[11px] uppercase tracking-wider transition-colors ${filter === v ? "bg-brand text-black" : "text-white/45 hover:text-white"}`}>
              {l}
            </button>
          ))}
        </div>
      </PageHeader>
      {!list ? (
        <p className="font-mono text-sm text-white/35">loading docket…</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4" data-testid="disputes-grid">
          {list.map((d, i) => <DisputeCard key={d.id} d={d} intel={intel[d.id]} delay={Math.min(i, 12) * 30} />)}
          {list.length === 0 && <p className="text-white/35 font-mono text-sm">No disputes in this state.</p>}
        </div>
      )}
    </div>
  );
}
